export default [
  {
    path: "/field5ydyunduan", // 无视频
    name: "field5ydyunduan",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field5ydks")
  },
  {
    path: "/field8ydyunduan", // 无视频
    name: "field8ydyunduan",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field8ydks")
  },
  {
    path: "/field9ydyunduan",
    name: "field9ydyunduan",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field9ydks")
  },
  {
    path: "/field12ydyunduan", // 无视频
    name: "field12ydyunduan",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field12ydks")
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/yunduan.js